import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './tableSkeletonStyle.module.scss';

var TableSkeleton = function TableSkeleton() {
  var arr = Array(4).fill(0);
  return /*#__PURE__*/_jsx("div", {
    className: styles.tableWrapper,
    children: /*#__PURE__*/_jsxs("table", {
      className: styles.table,
      children: [/*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("th", {
            children: " Name"
          }), /*#__PURE__*/_jsx("th", {
            children: " Score"
          }), /*#__PURE__*/_jsx("th", {
            className: styles.grade,
            children: "Grade"
          }), /*#__PURE__*/_jsx("th", {
            className: styles.words,
            children: "Words"
          }), /*#__PURE__*/_jsx("th", {
            className: styles.desktopOnlyColumn,
            children: "Days played"
          }), /*#__PURE__*/_jsx("th", {
            className: styles.desktopOnlyColumn,
            children: "City"
          }), /*#__PURE__*/_jsx("th", {
            className: styles.desktopOnlyColumn,
            children: "Awards"
          })]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: arr.map(function (index, i) {
          return /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("td", {
              className: styles.loading,
              children: /*#__PURE__*/_jsx("div", {
                className: styles.bar
              })
            }), /*#__PURE__*/_jsx("td", {
              className: styles.loading,
              children: /*#__PURE__*/_jsx("div", {
                className: styles.bar
              })
            }), /*#__PURE__*/_jsx("td", {
              className: "".concat(styles.loading, " ").concat(styles.grade),
              children: /*#__PURE__*/_jsx("div", {
                className: styles.bar
              })
            }), /*#__PURE__*/_jsx("td", {
              className: "".concat(styles.loading, " ").concat(styles.words),
              children: /*#__PURE__*/_jsx("div", {
                className: styles.bar
              })
            }), /*#__PURE__*/_jsx("td", {
              className: "".concat(styles.loading, " ").concat(styles.desktopOnlyColumn),
              children: /*#__PURE__*/_jsx("div", {
                className: styles.bar
              })
            }), /*#__PURE__*/_jsx("td", {
              className: "".concat(styles.loading, " ").concat(styles.desktopOnlyColumn),
              children: /*#__PURE__*/_jsx("div", {
                className: styles.bar
              })
            }), /*#__PURE__*/_jsx("td", {
              className: "".concat(styles.loading, " ").concat(styles.desktopOnlyColumn),
              children: /*#__PURE__*/_jsx("div", {
                className: styles.bar
              })
            })]
          }, i);
        })
      })]
    })
  });
};

export default TableSkeleton;